import React from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { getAppTheme } from './appTheme';

function AppThemeProvider({ children }) {
  const theme = React.useMemo(() => getAppTheme(), []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default AppThemeProvider;